/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { IPickerModel } from '@rhybus/api'
import React, { RefObject, useContext, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { mpfWhoHttp } from '../../../assets/ts/api/mpf-who-http'
import { DueOut as ServerDueoutType } from '../../../assets/ts/data/dueout/dueout'
import { PascodeMetadata } from '../../../assets/ts/data/pascode-metadata'
import { UserProfile } from '../../../assets/ts/data/user-profile'
import { filterRank, formatPhoneNumber, getUserProfileWithoutID } from '../../../assets/ts/general/general'
import useUserProfile from '../../../hooks/use-user-profile'
import { MetadataContext } from '../../../store/metadata-context-provider'
import { RoleContext } from '../../../store/role-context-provider'
import { UserContext } from '../../../store/user-context-provider'
import {
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  MAX_LENGTHS,
  SELECT_OPTION_STRING,
} from '../../../utils/constants/global-constants'
import CustomSelect from '../../../utils/controls/custom-select'
import InputCheckbox from '../../../utils/controls/input-checkbox'
import InputText from '../../../utils/controls/input-text'
import { CustomerOrgDetails, DueoutInputs, ValidationFields } from './dueout-form'

interface CustomerProps {
  CellPhoneProvider: any
  dueoutInputs: DueoutInputs
  existCustomerDetails: CustomerOrgDetails | undefined
  existingDueout: ServerDueoutType
  initialDueoutInput: DueoutInputs
  isSupported
  setDueoutInputs: React.Dispatch<React.SetStateAction<DueoutInputs>>
  setExistCustomerDetails: React.Dispatch<React.SetStateAction<CustomerOrgDetails | undefined>>
  setUniqueChange: (value: string) => void
  updateDueoutInput: (key: keyof DueoutInputs, value: number | string) => void
  validateLoginUser: () => void
  validationFields: ValidationFields
}

const CustomerDetails = ({
  CellPhoneProvider,
  dueoutInputs,
  existCustomerDetails,
  existingDueout,
  initialDueoutInput,
  isSupported,
  setDueoutInputs,
  setExistCustomerDetails,
  setUniqueChange,
  updateDueoutInput,
  validateLoginUser,
  validationFields,
}: CustomerProps) => {
  const { components, majcoms, pascodeMetadata, ranks, tooltipObj } = useContext(MetadataContext)
  const { me } = useContext(UserContext)
  const [statusOptions, setStatusOptions] = useState([SELECT_OPTION_STRING])
  const [userList, setuserList] = useState<Array<IPickerModel>>([])
  const [rankOptions, setRankOptions] = useState([SELECT_OPTION_STRING])
  const [matchedCustomerPascode, setMatchedCustomerPascode] = useState<Array<PascodeMetadata>>([])
  const [assignedLocationDropDown, setAssignedLocationDropDown] = useState<Array<string>>([])
  const [organizationDropDown, setOrganizationDropDown] = useState<Array<string>>([])
  const [pascodeDropDown, setPascodeDropDown] = useState<Array<string>>([])
  const [isPasCodeKnown, setIsPasCodeKnown] = useState<boolean>(true)
  const [peopleDropdownEmails, setPeopleDropdownEmails] = useState<string[]>([])
  const [showEditFields, setShowEditFields] = useState({
    location: false,
    organization: false,
    pasCode: true,
  })
  const [disableDODorDutymail, setDisableDODorDutymail] = useState<'dod' | 'dutymail' | null>(null)
  const [showReadonlyFields, setShowReadonlyFields] = useState<boolean>(false)
  useEffect(() => {
    const orgPASCODE = pascodeMetadata.filter(
      (item) => Number(item.AssignedComponentCode) === dueoutInputs.AssignedComponentCode
    )
    setMatchedCustomerPascode(orgPASCODE)
  }, [pascodeMetadata, dueoutInputs.AssignedComponentCode])
  useEffect(() => {
    const assignedlocations = [
      ...new Set(
        matchedCustomerPascode.map(({ Installation }) => {
          return Installation
        })
      ),
    ].filter((item) => item !== undefined)
    const pascodes = [
      ...new Set(
        matchedCustomerPascode.map(({ PASCODE }) => {
          return PASCODE
        })
      ),
    ].filter((item) => item !== undefined)
    setAssignedLocationDropDown(assignedlocations)
    setPascodeDropDown(pascodes)
  }, [matchedCustomerPascode])
  const generateStatusOption = (assignComponenetCode: number) => {
    const profileStatus = [
      ...new Set(
        ranks
          ?.filter((assCom) => assCom.AssignedComponentCode === assignComponenetCode)
          .map(({ Status }) => {
            return Status
          })
      ),
    ].map((rank) => {
      return { label: rank, value: rank }
    })
    setStatusOptions([SELECT_OPTION_STRING, ...profileStatus])
  }
  useEffect(() => {
    generateStatusOption(dueoutInputs.AssignedComponentCode)
    setRankOptions([SELECT_OPTION_STRING])
  }, [ranks, dueoutInputs.AssignedComponentCode])
  useEffect(() => {
    if (existingDueout) {
      const filteredGrades = filterRank(
        existingDueout.CustomerStatus,
        ranks,
        existingDueout.AssignedComponentCode
      )
      const rankOptions =
        filteredGrades.length === 1 ? filteredGrades : [SELECT_OPTION_STRING, ...filteredGrades]
      setRankOptions(rankOptions)
      setShowReadonlyFields(true)
      setShowEditFields({
        location: true,
        organization: true,
        pasCode: true,
      })
    } else setRankOptions([SELECT_OPTION_STRING])
  }, [existingDueout])
  const componentsOptions = components.map((component) => ({
    label: component.Component,
    value: component.ComponentCode,
  }))

  function getMAJCOMCode(name: string) {
    return (majcoms as any).find((item) => item.Label === name).Value
  }
  const onChangeAssignedComponent = (e: { label: string; value: number }) => {
    const newState = {
      AssignedComponentCode: e.value,
      CustomerStatus: ALL_SELECT_VALUE_STRING,
      Location: '',
      OrgMAJCOM: '',
      Organization: '',
      PASCODE: '',
      PascodeID: -1,
      Rank: ALL_SELECT_VALUE_STRING,
      ServicingBy: '',
      ServicingMajcom: '',
      ServicingMajcomCode: ALL_SELECT_VALUE,
      ServicingOrganization: '',
    }
    setDueoutInputs((prevState) => ({
      ...prevState,
      ...newState,
    }))
    setIsPasCodeKnown(true)
    setShowReadonlyFields(false)
    setShowEditFields({
      location: false,
      organization: false,
      pasCode: true,
    })
    generateStatusOption(e.value)
    setRankOptions([SELECT_OPTION_STRING])
  }
  function onChangeStatus(e: { label: string; value: string }) {
    const filteredGrades = filterRank(e.value, ranks, dueoutInputs.AssignedComponentCode)
    const rankOptions =
      filteredGrades.length === 1 ? filteredGrades : [SELECT_OPTION_STRING, ...filteredGrades]
    setRankOptions(rankOptions)
    setDueoutInputs((prev) => ({
      ...prev,
      CustomerStatus: e.value,
      Rank: filteredGrades.length === 1 ? rankOptions[0].value : '',
    }))
  }
  function onChangeRank(e: { label: string; value: string }) {
    updateDueoutInput('Rank', e.value)
  }
  const onChangePhoneProvider = (e: { label: string; value: string }) => {
    updateDueoutInput('PersonalPhoneProvider', e.value)
  }
  const resetFields = (changeinput: string, value: string) => {
    setShowReadonlyFields(false)
    setShowEditFields((prev) => ({
      ...prev,
      location: changeinput === 'Location' || changeinput === 'Organization',
      organization: changeinput === 'Organization',
      pasCode: changeinput === 'PASCODE' || changeinput === 'DutyEmail' || changeinput === 'Dod',
    }))
    if (changeinput === 'DutyEmail' || changeinput === 'Dod') {
      setIsPasCodeKnown(true)
    }
    setDueoutInputs((prev) => ({
      ...prev,
      AssignedComponentCode:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? initialDueoutInput.AssignedComponentCode
          : prev.AssignedComponentCode,
      CustomerStatus:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? initialDueoutInput.CustomerStatus
          : prev.CustomerStatus,
      DoDNumber:
        changeinput === 'DutyEmail'
          ? initialDueoutInput.DoDNumber
          : changeinput === 'Dod'
          ? value
          : prev.DoDNumber,
      DutyEmail:
        changeinput === 'DutyEmail'
          ? value
          : changeinput === 'Dod'
          ? initialDueoutInput.DutyEmail
          : prev.DutyEmail,
      DutyPhone:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? initialDueoutInput.DutyPhone
          : prev.DutyPhone,
      IsValidLocation: !showEditFields.location || changeinput === 'Organization',
      IsValidOrganization: !showEditFields.organization,
      IsValidPASCODE: !isPasCodeKnown,
      Location:
        changeinput === 'Location' ? value : changeinput === 'Organization' ? prev.Location : '',
      OrgMAJCOM: '',
      Organization: changeinput === 'Organization' ? value : '',
      PASCODE: changeinput === 'PASCODE' ? value : '',
      PersonalEmail:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? initialDueoutInput.PersonalEmail
          : prev.PersonalEmail,
      PersonalPhone:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? initialDueoutInput.PersonalPhone
          : prev.PersonalPhone,
      PersonalPhoneProvider:
        changeinput === 'DutyEmail' || changeinput === 'Dod'
          ? initialDueoutInput.PersonalPhoneProvider
          : prev.PersonalPhoneProvider,
      Rank:
        changeinput === 'DutyEmail' || changeinput === 'Dod' ? initialDueoutInput.Rank : prev.Rank,
      ServicingBy: '',
      ServicingOrganization: '',
    }))
  }

  const changePASCODE = (e: { target: { id: string; value: string } }) => {
    resetFields(e.target.id, e.target.value)
    updateDueoutInput(e.target.id as keyof DueoutInputs, e.target.value)
  }

  const changeLocation = (e: { target: { id: string; value: string } }) => {
    resetFields(e.target.id, e.target.value)
    updateDueoutInput(e.target.id as keyof DueoutInputs, e.target.value)
  }

  const onChangeOrganization = (e: { target: { id: string; value: string } }) => {
    resetFields(e.target.id, e.target.value)
    updateDueoutInput(e.target.id as keyof DueoutInputs, e.target.value)
  }

  const onChangePhoneNumber = (e: { target: { id: string; value: string } }) => {
    const { id, value } = e.target
    const numbersOnly = /^[0-9\b]+$/
    const numbersWithSymbolsAndSpace = /^[0-9()\b\s-]+$/
    if (value === '' || (numbersOnly.test(value) && value.length < 11)) {
      updateDueoutInput(id as keyof DueoutInputs, value)
    }
    if (numbersWithSymbolsAndSpace.test(value) && value.length === 13) {
      const output = value.slice(0, -1).replace(/[^\d]/g, '')
      updateDueoutInput(id as keyof DueoutInputs, output)
    }
  }
  const onChangePersonalMail = (e: { target: { id: string; value: string } }) => {
    const { id, value } = e.target
    updateDueoutInput(id as keyof DueoutInputs, value)
  }

  const onChangeUser = async (value: string) => {
    resetFields('DutyEmail', value)
    setExistCustomerDetails(undefined)
    setDisableDODorDutymail(null)
    if (value.trim().length > 2) {
      const userList = [...(await mpfWhoHttp().Picker(value.trim()))]
      setuserList(userList)
      const userName = userList.map((item) => item.email)
      setPeopleDropdownEmails(userName)
    }
  }
  const customerOrgDetails = (pascode?: string | undefined, organization?: string) => {
    const {
      AssignedComponentCode,
      Code,
      Installation,
      OrgMAJCOM,
      Organization,
      PASCODE,
      ServicingBy,
      ServicingMAJCOM,
      ServicingOrganization,
    } = pascode
      ? matchedCustomerPascode.find(({ PASCODE }) => PASCODE === pascode) ?? {}
      : matchedCustomerPascode.find(({ Organization }) => Organization === organization) ?? {}

    setDueoutInputs((prev) => ({
      ...prev,
      IsValidLocation: true,
      IsValidOrganization: true,
      IsValidPASCODE: true,
      Location: Installation as string,
      OrgMAJCOM: OrgMAJCOM as string,
      Organization: Organization as string,
      PASCODE: PASCODE as string,
      PascodeID: Code as number,
      ServicingBy: ServicingBy as string,
      ServicingMajcom: ServicingMAJCOM as string,
      ServicingMajcomCode: getMAJCOMCode(ServicingMAJCOM as string),
      ServicingOrganization: ServicingOrganization as string,
    }))
    setShowReadonlyFields(true)
    isSupported(AssignedComponentCode, PASCODE, ServicingOrganization)
  }
  const selectPASCODE = (pascode: string) => {
    customerOrgDetails(pascode)
    setShowEditFields((prev) => ({
      ...prev,
      location: true,
      organization: true,
    }))
  }
  const selectOrganization = (organization: string) => {
    customerOrgDetails(undefined, organization)
    setShowEditFields((prev) => ({
      ...prev,
      pasCode: true,
    }))
  }
  const selectLocation = (location: string) => {
    setShowEditFields((prev) => ({
      ...prev,
      organization: true,
    }))
    const orgPASCODE = matchedCustomerPascode.filter((item) => item.Installation === location)
    const organizations = [
      ...new Set(
        orgPASCODE.map(({ Organization }) => {
          return Organization
        })
      ),
    ].filter((item) => item !== undefined)
    setOrganizationDropDown(organizations)
    setDueoutInputs((prev) => ({
      ...prev,
      IsValidLocation: true,
      IsValidOrganization: false,
      IsValidPASCODE: true,
      Location: location,
    }))
  }
  function updateCustomerInputs(
    loginDetails: UserProfile,
    input: keyof DueoutInputs,
    value: string
  ) {
    if (loginDetails) {
      setDisableDODorDutymail(input === 'DoDNumber' ? 'dutymail' : 'dod')
      setExistCustomerDetails({
        AssignedComponentCode: loginDetails.AssignedComponentCode,
        CustomerStatus: loginDetails.CustomerStatus,
        DoDNumber: loginDetails.DoDNumber,
        DutyEmail: loginDetails.DutyEmail,
        DutyPhone: loginDetails.DutyPhone,
        Location: loginDetails.Installation,
        OrgMAJCOM: loginDetails.OrgMAJCOM,
        Organization: loginDetails.Organization,
        PASCODE: loginDetails.PASCODE,
        PascodeID: loginDetails.PascodeID,
        PersonalEmail: loginDetails.PersonalEmail,
        PersonalPhone: loginDetails.PersonalPhone,
        PersonalPhoneProvider: loginDetails.PersonalPhoneProvider,
        Rank: loginDetails.Rank,
        ServicingBy: loginDetails.PASCODEServicedBy,
        ServicingMajcom: loginDetails.ServicingMAJCOM,
        ServicingMajcomCode: getMAJCOMCode(loginDetails.ServicingMAJCOM),
        ServicingOrganization: loginDetails.ServicingOrganization,
        UserDisplayName: loginDetails.UserDisplayName,
        UserRID: loginDetails.UserRID,
        eKey: loginDetails.eKey,
        eTag: loginDetails.eTag,
      })
      generateStatusOption(loginDetails.AssignedComponentCode)
      const filteredGrades = filterRank(
        loginDetails.CustomerStatus,
        ranks,
        loginDetails.AssignedComponentCode
      )
      const rankOptions =
        filteredGrades.length === 1 ? filteredGrades : [SELECT_OPTION_STRING, ...filteredGrades]
      setRankOptions(rankOptions)
      setShowEditFields({ location: true, organization: true, pasCode: true })
      setShowReadonlyFields(true)
    }
    setDueoutInputs((prev) => ({
      ...prev,
      AssignedComponentCode: loginDetails?.AssignedComponentCode ?? prev.AssignedComponentCode,
      CustomerId: loginDetails?.UserRID ?? '',
      CustomerStatus: loginDetails?.CustomerStatus ?? prev.CustomerStatus,
      DoDNumber: input === 'DoDNumber' ? value : loginDetails?.DoDNumber ?? prev.DoDNumber,
      DutyEmail: input === 'DutyEmail' ? value : loginDetails?.DutyEmail ?? prev.DutyEmail,
      DutyPhone: loginDetails?.DutyPhone ?? prev.DutyPhone,
      IsValidDutyEmail: input === 'DutyEmail' ? true : prev.IsValidDutyEmail,
      IsValidLocation: loginDetails?.Installation ? true : prev.IsValidLocation,
      IsValidOrganization: loginDetails?.Organization ? true : prev.IsValidOrganization,
      IsValidPASCODE: loginDetails?.PASCODE ? true : prev.IsValidPASCODE,
      Location: loginDetails?.Installation ?? prev.Location,
      OrgMAJCOM: loginDetails?.OrgMAJCOM ?? prev.OrgMAJCOM,
      Organization: loginDetails?.Organization ?? prev.Organization,
      PASCODE: loginDetails?.PASCODE ?? prev.PASCODE,
      PascodeID: loginDetails?.PascodeID ?? prev.PascodeID,
      PersonalEmail: loginDetails?.PersonalEmail ?? prev.PersonalEmail,
      PersonalPhone: loginDetails?.PersonalPhone ?? prev.PersonalPhone,
      PersonalPhoneProvider: loginDetails?.PersonalPhoneProvider ?? prev.PersonalPhoneProvider,
      Rank: loginDetails?.Rank ?? prev.Rank,
      ServicingBy: loginDetails?.PASCODEServicedBy ?? prev.ServicingBy,
      ServicingMajcom: loginDetails?.ServicingMAJCOM ?? prev.ServicingMajcom,
      ServicingMajcomCode: loginDetails
        ? getMAJCOMCode(loginDetails.ServicingMAJCOM)
        : prev.ServicingMajcomCode,
      ServicingOrganization: loginDetails?.ServicingOrganization ?? prev.ServicingOrganization,
    }))
    isSupported(
      loginDetails.AssignedComponentCode,
      loginDetails.PASCODE,
      loginDetails.ServicingOrganization
    )
  }
  const selectedUser = async (value: string) => {
    const loginuserMail = me.email
    setExistCustomerDetails(undefined)
    if (loginuserMail === value) {
      validateLoginUser()
    } else {
      const user = await mpfWhoHttp().Picker(value)
      const dueOutCustomerDoD = user[0].edipi
      setDueoutInputs((prev) => ({
        ...prev,
        DoDNumber: dueOutCustomerDoD,
      }))
      let profile: any = await getUserProfileWithoutID(value, 'DutyEmail')
      
      if (Object.values(profile).length === 0) {
        profile = await getUserProfileWithoutID(dueOutCustomerDoD, 'DoDNumber')
        if (profile.DutyEmail && profile.DutyEmail !== value) {
          profile.DutyEmail = user[0].email,
          setUniqueChange('Duty Email has recently changed.') // Sets error message for email change
        }
      }
      if (profile) updateCustomerInputs(profile as UserProfile, 'DutyEmail', value)
      else {
        setDisableDODorDutymail('dod')
        const user = userList.find((item) => item.email === value) as IPickerModel
        updateCustomerDetails(user)
      }
    }
  }
  const onChangeDODNumber = async (e: { target: { id: string; value: string } }) => {
    const { id, value } = e.target
    const numbersOnly = /^[0-9\b]+$/
    setExistCustomerDetails(undefined)
    if (value === '' || (numbersOnly.test(value) && value.length < 11)) {
      updateDueoutInput(id as keyof DueoutInputs, value)
      setDisableDODorDutymail(null)
      resetFields('Dod', value)
    }
    if (value.length === 10) {
      const loginDOD = me.edipi
      if (value === loginDOD) {
        updateDueoutInput(id as keyof DueoutInputs, '')
        validateLoginUser()
      } else if (value !== loginDOD) {
        const user = await mpfWhoHttp().Other(value.trim())
        const dueOutCustomerDoD = user[0].edipi
        const dueoutCustomerEmail = user[0].email
        setDueoutInputs((prev) => ({
          ...prev,
          DoDNumber: dueOutCustomerDoD,
        }))
        let profile: any = await getUserProfileWithoutID(dueoutCustomerEmail, 'DutyEmail')
        
        if (Object.values(profile).length === 0) {
          profile = await getUserProfileWithoutID(dueOutCustomerDoD, 'DoDNumber')
          if (profile.DutyEmail && profile.DutyEmail !== dueoutCustomerEmail) {
            profile.DutyEmail = user[0].email,
            setUniqueChange('Duty Email has recently changed.') // Sets error message for email change
          }
        }
        updateCustomerInputs(profile as UserProfile, 'DoDNumber', value)
      }
    }
  }
  const updateCustomerDetails = (user: IPickerModel) => {
    setExistCustomerDetails((prev) => ({
      ...prev,
      DoDNumber: user.edipi,
      DutyEmail: user.email,
      UserDisplayName: user.persona,
      UserRID: user.rid,
      eKey: '',
      eTag: '',
    }))
    setDueoutInputs((prev) => ({
      ...prev,
      CustomerId: user.rid,
      DoDNumber: user.edipi,
      DutyEmail: user.email,
    }))
  }

  function knowPascode(e: { target: { value: string } }) {
    const { value } = e.target
    setIsPasCodeKnown(value === 'Yes' ? true : false)
    setShowEditFields((prev) => ({
      ...prev,
      location: value === 'Yes' ? false : true,
      organization: false,
      pasCode: value === 'Yes' ? true : false,
    }))
    setShowReadonlyFields(false)
    setDueoutInputs((prev) => ({
      ...prev,
      IsValidLocation: value === 'Yes' ? true : false,
      IsValidOrganization: true,
      IsValidPASCODE: value === 'Yes' ? false : true,
      Location: '',
      OrgMAJCOM: '',
      Organization: '',
      PASCODE: '',
      PascodeID: -1,
      ServicingBy: '',
      ServicingOrganization: '',
    }))
  }
  return (
    <div className='customerdDetailsinfo'>
      <div className='row'>
        <div className='col-md-12 mt-0 mb-2'>
          <div className='heading p-1'>
            <h2
              aria-label='Customer Details'
              className='
              m-0 p-2 color-primary poppins-semibold text-uppercase font-12 maxfitcontent'
              tabIndex={0}
            >
              Customer Details
            </h2>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <InputText
            changeHandler={onChangeDODNumber}
            className='form-lg font-13 sourcesanspro'
            disabled={disableDODorDutymail === 'dod' || existingDueout?.DoDNumber ? true : false}
            formClassName=' form-vertical'
            info={tooltipObj.dodNumber?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'DoDNumber',
              maxLength: '10',
              name: 'DoD ID Number',
              placeholder: 'DoD ID Number',
              value: dueoutInputs.DoDNumber,
            }}
            isInfo
            isMandatory
            label='DoD ID Number'
            ref={validationFields.DoDIDNumber.link}
          />
        </div>
        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect'
            disabled={existingDueout?.DutyEmail ? true : false}
            formClassName='form-vertical'
            id='AssignedComponent'
            info={tooltipObj.assignedComp?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label='Assigned Component'
            name='Assigned Component'
            onChange={onChangeAssignedComponent}
            options={componentsOptions}
            value={dueoutInputs.AssignedComponentCode}
          />
        </div>
        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect '
            formClassName='form-vertical'
            id='ProfileStatus'
            info={tooltipObj.status?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label='Status'
            name='Status'
            onChange={onChangeStatus}
            options={statusOptions}
            ref={validationFields.Status.link}
            value={dueoutInputs.CustomerStatus}
          />
        </div>
        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect '
            formClassName='form-vertical'
            id='ProfileRank'
            info={tooltipObj.rank?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label='Rank'
            name='Rank'
            onChange={onChangeRank}
            options={rankOptions}
            ref={validationFields.Rank.link}
            value={dueoutInputs.Rank}
          />
        </div>
        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <InputText
            changeHandler={(e) => {
              onChangeUser(e.target.value)
            }}
            className='form-lg font-13 sourcesanspro'
            data={peopleDropdownEmails}
            disabled={
              disableDODorDutymail === 'dutymail' || existingDueout?.DutyEmail ? true : false
            }
            formClassName=' form-vertical'
            info={tooltipObj.dutyEmail?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'DutyEmail',
              maxLength: '250',
              name: 'Duty Email',
              placeholder: 'Enter a name or email address...',
            }}
            isInfo
            isMandatory
            label='Duty Email'
            onSelect={selectedUser}
            ref={validationFields.DutyEmail.link}
            type='peopel-picker'
            value={dueoutInputs.DutyEmail}
          />
        </div>
        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <InputText
            changeHandler={onChangePhoneNumber}
            className='form-lg font-13 sourcesanspro'
            formClassName=' form-vertical'
            info={tooltipObj.dutyPhone?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'DutyPhone',
              maxLength: '250',
              name: 'Duty Phone',
              placeholder: ' (123) 213-1231',
              value: formatPhoneNumber(dueoutInputs.DutyPhone),
            }}
            isInfo
            isMandatory
            label='Duty Phone'
            ref={validationFields.DutyPhone.link}
          />
        </div>

        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <InputText
            changeHandler={onChangePhoneNumber}
            className='form-lg font-13 sourcesanspro'
            formClassName=' form-vertical'
            info={tooltipObj.dueOutCellPhone?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'PersonalPhone',
              maxLength: '250',
              name: 'Cell Phone Number',
              placeholder: ' (123) 213-1231',
              value: formatPhoneNumber(dueoutInputs.PersonalPhone as string),
            }}
            isInfo
            label='Cell Phone Number'
            ref={validationFields.PersonalPhone.link}
          />
        </div>

        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
            formClassName='form-vertical'
            id='CellPhoneProvider'
            info={tooltipObj.dueOutCellProvider?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            label='Cell Phone Provider'
            name='Cell Phone Provider'
            onChange={onChangePhoneProvider}
            options={CellPhoneProvider}
            value={dueoutInputs.PersonalPhoneProvider}
          />
        </div>
        <div className='mb-1 col-xl-3 col-lg-4 col-md-6 col-sm-12 mt-2'>
          <InputText
            changeHandler={onChangePersonalMail}
            className='form-lg font-13 sourcesanspro'
            formClassName=' form-vertical'
            info={tooltipObj.dueOutPersonalEmail?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'PersonalEmail',
              maxLength: '250',
              name: 'Personal Email',
              placeholder: 'Personal Email',
              value: dueoutInputs.PersonalEmail,
            }}
            isInfo
            label='Personal Email'
            ref={validationFields.PersonalMail.link}
          />
        </div>
      </div>
      <div className='mt-3'>
        <div className='mb-2 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
          <div className='d-flex me-3'>
            <label
              className='font-12 poppins-medium title-color form-horztional'
              htmlFor='Do you know the PASCODE?'
            >
              Do You Know The Unit PASCODE? <span className='mandatory me-1'>*</span>
              <span
                className='tool-tip tooltip-bottom font-12 sourcesanspro'
                data-tip='Do You Know The Unit PASCODE?'
              >
                <span className='icon-info color-primary'></span>
              </span>
            </label>
          </div>
          <div className='d-flex align-items-center'>
            <InputCheckbox
              formClassName='d-flex align-items-center'
              inputProps={{
                arialabel: 'Yes',
                checked: isPasCodeKnown,
                className: 'font-12 poppins-medium title-color mx-2',
                id: 'YesRadio',
                label: 'Yes',
                name: 'Pascoderadio',
                type: 'radio',
                value: 'Yes',
              }}
              onChange={knowPascode}
            />
            <InputCheckbox
              formClassName='d-flex align-items-center'
              inputProps={{
                arialabel: 'No',
                checked: !isPasCodeKnown,
                className: 'font-12 poppins-medium title-color mx-2',
                id: 'NoRadio',
                label: 'No',
                name: 'Pascoderadio',
                type: 'radio',
                value: 'No',
              }}
              onChange={knowPascode}
            />
          </div>
        </div>
        <div className='row'>
          {showEditFields.location && (
            <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-3 mt-2'>
              <InputText
                changeHandler={changeLocation}
                className='border w-100 form-lg border-radius03  font-13 sourcesanspro'
                data={assignedLocationDropDown}
                disabled={isPasCodeKnown}
                formClassName=' form-vertical '
                info={tooltipObj.dueOutInstallation?.TooltipDescription}
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color mb-1',
                  id: 'Location',
                  maxLength: '250',
                  name: 'What is your Assigned Location?',
                  placeholder: 'Assigned Location? ',
                }}
                isInfo
                isMandatory
                label='What is your Assigned Location?'
                onSelect={selectLocation}
                ref={validationFields.Location.link}
                searchgroup=' w-100 d-flex align-items-center inputswithicon'
                value={dueoutInputs.Location}
              />
            </div>
          )}
          {showEditFields.organization && (
            <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-20per mt-2'>
              <InputText
                changeHandler={onChangeOrganization}
                className='border w-100 form-lg border-radius03  font-13 sourcesanspro'
                data={organizationDropDown}
                disabled={isPasCodeKnown}
                formClassName=' form-vertical'
                info={tooltipObj.dueOutOrg?.TooltipDescription}
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color mb-1',
                  id: 'Organization',
                  maxLength: '250',
                  name: 'What is your Organization?',
                  placeholder: 'Organization?',
                }}
                isInfo
                isMandatory
                label='What is your Organization?'
                onSelect={selectOrganization}
                ref={validationFields.Organization.link}
                searchgroup=' w-100 d-flex align-items-center inputswithicon'
                value={dueoutInputs.Organization}
              />
            </div>
          )}
          {showEditFields.pasCode && (
            <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-10per mt-2'>
              <InputText
                changeHandler={changePASCODE}
                className='form-lg font-13 sourcesanspro'
                data={pascodeDropDown}
                disabled={!isPasCodeKnown}
                formClassName=' form-vertical'
                info={tooltipObj.PASCODE?.TooltipDescription}
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color mb-1',
                  id: 'PASCODE',
                  maxLength: MAX_LENGTHS.EIGHT,
                  name: 'PASCODE',
                  placeholder: 'PASCODE',
                }}
                isInfo
                isMandatory
                label='PASCODE'
                maxLength={8}
                onSelect={selectPASCODE}
                ref={validationFields.PASCODE.link}
                value={dueoutInputs.PASCODE}
              />
            </div>
          )}
          {showReadonlyFields && (
            <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-20per mt-2'>
              <InputText
                className='form-lg font-13 sourcesanspro'
                disabled
                formClassName=' form-vertical'
                info={tooltipObj.servicingBy?.TooltipDescription}
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color mb-1',
                  id: 'ServicedBy',
                  maxLength: '250',
                  name: 'PASCODE Serviced By',
                  placeholder: 'PASCODE Serviced by',
                  value: dueoutInputs.ServicingBy,
                }}
                isInfo
                label='PASCODE Serviced By'
              />
            </div>
          )}
          {showReadonlyFields && (
            <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-20per mt-2'>
              <InputText
                className='form-lg font-13 sourcesanspro'
                disabled
                formClassName=' form-vertical'
                info={tooltipObj.servicingOrg?.TooltipDescription}
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color mb-1',
                  id: 'ServicingOrganization',
                  maxLength: '250',
                  name: 'Servicing Organization',
                  placeholder: '96MPF',
                  value: dueoutInputs.ServicingOrganization,
                }}
                isInfo
                label='Servicing Organization'
              />
            </div>
          )}
          {showReadonlyFields && (
            <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-20per mt-2'>
              <InputText
                className='form-lg font-13 sourcesanspro'
                disabled
                formClassName='form-vertical'
                info={tooltipObj.profileServicingMAJCOM?.TooltipDescription}
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color mb-1',
                  id: 'ServicingMAJCOM',
                  maxLength: '250',
                  name: 'Servicing MAJCOM',
                  value: dueoutInputs.ServicingMajcom,
                }}
                isInfo
                label='Servicing MAJCOM'
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
export default CustomerDetails
